// extracted by mini-css-extract-plugin
module.exports = {"ratingSection":"CourseRatingView_ratingSection__oHCFU","rateValue":"CourseRatingView_rateValue__7YuXd","ratingCount":"CourseRatingView_ratingCount__Qiq9m"};